export const RATING_FETCH_MORE = 'RATING_FETCH_MORE' as const

export const setRatingFetchMoreAction = () => ({
  type: RATING_FETCH_MORE,
})
